<template>
  <div>
    <div>
      <mdb-row>
        <mdb-col md="4" style="margin-bottom: 10px;">
          <div class="form__group">
            <div class="form__group">
              <label class="form__label">Tomar foto de hij@:</label>
            </div>
          </div>
        </mdb-col>
      </mdb-row>

      <mdb-row>
        <mdb-col md="2" style="text-align: left;">
          <div v-if="fileAvatar == ''" class="image-upload">
            <label for="image-release">
              <img @mouseup="mouseUpIcon('release')" @mousedown="mouseDownIcon('release')"
                @mouseleave="mouseLeaveIcon('release')" @mouseover="mouseOverIcon('release')"
                @click="
                  $refs.camera.toggleModal();
                $refs.webcam.start();
                                                                                                                                                                " :src="'/img/icons/' + releaseIcon" class="icon"
                alt="agregar foto" style="cursor: pointer;" />
            </label>
          </div>
          <div v-else class="image-upload input-group mb-5">
            <img :src="fileAvatar" class="avatar-pic" alt="Profile Picture" />
            <img :src="'/img/icons/editar-foto.svg'" class="edit-pic" alt="Profile Picture" style="cursor: pointer;"
              @click="
                $refs.camera.toggleModal();
              $refs.webcam.start();
                                                                                                                                              " />
          </div>
        </mdb-col>

        <mdb-col md="8" style="margin-bottom: 10px;">
          <div>
            <div>
              <mdb-row class="mt-3">
                <mdb-col md="6">
                  <!-- <div class="input-group" style="margin-top: 3%; margin-left: 1%;"> -->
                  <label for="input" class="form__label">CURP:</label>
                  <!-- <div class="input-group-prepend" style="width: 65%;"> -->
                  <input type="text" v-model="curp" id="input" class="form__input" style="text-transform: uppercase;"
                    minlength="18" placeholder="Ingresa la CURP de tu hij@" required
                    pattern="[A-Z]{1}[AEIOUX]{1}[A-Z]{2}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[HM]{1}(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[0-9A-Z]{1}[0-9]{1}" />
                  <!-- </div> -->
                  <div v-if="invalidChild" class="trust1-danger" style="font-weight: bold;">
                    <div> Solo se permiten hijos hombres menores o igual de 27 años</div>
                  </div>
                  <validation-error :validation="$v.curp" field="CURP"></validation-error>

                  <!-- esto ya estaba comentado-->
                  <!-- <div
                        v-if="!curpOK"
                        class="curp-upload"
                        style="height: 1px; margin-left: -5px;"
                      >
                        <label for="curp-input">
                          <img :src="'/img/icons/'+uploadIcon" class="icon uploadIcon" />
                        </label>
                        <input
                          type="file"
                          accept="image/jpeg, image/png, application/pdf"
                          name="file"
                          id="curp-input"
                          @change="uploadCURP"
                        />
                      </div>
                      <div v-else class="curp-upload" style="height: 1px; margin-left: -5px;">
                        <img :src="'/img/icons/'+approvedIcon" class="icon approvedIcon" />
              </div>-->
                  <!-- </div> -->

                </mdb-col>
              </mdb-row>
            </div>

            <div>
              <mdb-row class="mt-3">
                <mdb-col md="6">
                  <label for="input_name" class="form__label">Nombre:</label>
                  <input type="text" id="input_name" class="form__input" style="text-transform: uppercase;"
                    v-model="name" />
                </mdb-col>
              </mdb-row>
              <mdb-row>
                <mdb-col md="6">
                  <label for="input_last" class="form__label">Apellido Paterno:</label>
                  <input type="text" id="input_last" class="form__input" style="text-transform: uppercase;"
                    v-model="lastName" />
                </mdb-col>
                <mdb-col md="6">
                  <label for="input_last2" class="form__label">Apellido Materno:</label>
                  <input type="text" id="input_last2" class="form__input" style="text-transform: uppercase;"
                    v-model="lastName2" />
                </mdb-col>
              </mdb-row>
              <mdb-row class="mt-3">
                <mdb-col md="4">
                  <div class="form__group">
                    <label for="input_sex" class="form__label">Sexo:</label>
                    <select name="sexo" v-model="sexo" id="input_sex" class="browser-default custom-select">>
                      <option value="HOMBRE">HOMBRE</option>
                      <option value="MUJER">MUJER</option>
                    </select>
                  </div>
                  <!-- <label for="input_sex" class="form__label">Sexo:</label>
                  <input
                    type="text"
                    id="input_sex"
                    class="form__input"
                    style="width: 70%"
                    v-model="sexo"
                     :disabled="disabledCurp"
                  /> -->
                </mdb-col>
              </mdb-row>
              <mdb-row class="mt-3">
                <mdb-col md="4">
                  <label for="input_date" class="form__label">Fecha de Nacimiento:</label>
                  <input type="text" id="input_date" class="split" tabindex="1" maxlength="2" placeholder="DD"
                    v-model="dia" readonly @click="$refs.filterDay.toggleModal()" />
                  <input type="text" id="input_date" class="split" tabindex="2" maxlength="2" placeholder="MM"
                    v-model="mes" readonly @click="$refs.filterDay.toggleModal()" />
                  <input type="text" id="input_date" class="split" tabindex="3" maxlength="4" placeholder="AAAA"
                    v-model="year" readonly @click="$refs.filterDay.toggleModal()" />
                </mdb-col>
              </mdb-row>
              <mdb-row class="mt-3 mb-5">
                <mdb-col md="4">
                  <div class="form__group">
                    <label for="input_entity" class="form__label">Entidad de Nacimiento:</label>
                    <select v-model="state" name="state" id="input_entity" class="browser-default custom-select">
                      <option v-for="(value, index) in locations" :key="index + '_state'">{{ value }}</option>
                    </select>
                  </div>
                </mdb-col>
              </mdb-row>
            </div>
            <div class="form__group mt-5">
              <div v-show="fileCurp == null" class="form__group">
                <label :for="'curp-input' + index" class="form__label mb-3" style="transform: translateY(3px);">Sube la
                  CURP:</label>
                <label :for="'curp-input' + index" class="btn-label">
                  <img :src="'/img/icons/' + uploadIcon" style="width: 20px;" />
                  SUBIR CURP
                </label>
                <input type="file" accept="application/pdf" name="file" :id="'curp-input' + index"
                  style="visibility: hidden;" @change="uploadCURP" />
              </div>
              <validation-error :validation="$v.fileCurp"></validation-error>
              <div v-show="fileCurp != null" class="input-group">
                <btn :text="'¡LISTO!'" :type="'primary-admin-success'" style="float:left;"></btn>

                <img style="margin-top: 10px; cursor: pointer;" :src="'/img/icons/' + watchButton"
                  @click="viewPdf(fileCurp, 'CURP')" @mouseup="mouseUpIcon('watch')" @mousedown="mouseDownIcon('watch')"
                  @mouseleave="mouseLeaveIcon('watch')" />
              </div>
            </div>

            <div v-if="isMayor" class="input-group" style="margin-top: 3%; margin-left: 1%;">
              <!-- <label for="input" class="form__label">CURP:</label> -->
              <!-- <div class="input-group-prepend" style="width: 75%;">
                        <input
                          type="text"
                          v-model="messageIne"
                          id="input"
                          class="form__input"
                          style="width: 120% !important;"
                          minlength="18"
                          placeholder="Sube tu INE o Pasaporte en formato png/jpeg/jpg"
                          required
                          disabled
                        />
                      </div>

                      <div
                        v-if="!ineOK"
                        class="curp-upload"
                        style="height: 1px; margin-left: -5px;"
                      >
                        <label for="ine-input">
                          <img :src="'/img/icons/'+uploadIcon" class="icon uploadIcon" />
                        </label>
                        <input
                          type="file"
                          accept="image/jpeg, image/png"
                          name="file"
                          id="ine-input"
                          @change="UploadIdentificacion"
                        />
                      </div>
                      <div v-else class="curp-upload" style="height: 1px; margin-left: -5px;">
                        <img :src="'/img/icons/'+approvedIcon" class="icon approvedIcon" />
              </div>-->
              <div class="form__group mt-5">
                <div v-show="fileIne == null" class="form__group">
                  <label :for="'id-input' + index" class="form__label mb-3" style="transform: translateY(3px);">Sube tu
                    Identificación <small>(Vigente, legible, escaneada, ambos lados)</small>:</label>
                  <label :for="'id-input' + index" class="btn-label">
                    <img :src="'/img/icons/' + uploadIcon" style="width: 20px;" />
                    SUBIR IDENTIFICACIÓN
                  </label>
                  <input type="file" accept="application/pdf" name="file" :id="'id-input' + index"
                    style="visibility: hidden;" @change="UploadIdentificacion" />
                </div>
                <validation-error :validation="$v.fileIne"></validation-error>
                <div v-show="fileIne != null" class="input-group">
                  <btn :text="'¡LISTO!'" :type="'primary-admin-success'" style="float:left;"></btn>

                  <img style="margin-top: 10px; cursor: pointer;" :src="'/img/icons/' + watchButton"
                    @click="viewPdf(fileIne, 'Identificación')" @mouseup="mouseUpIcon('watch')"
                    @mousedown="mouseDownIcon('watch')" @mouseleave="mouseLeaveIcon('watch')" />
                </div>
              </div>
            </div>

            <div class="form__group mt-5">
              <div v-show="actaUrl == null" class="form__group">
                <label for="curp" class="form__label mb-3" style="transform: translateY(3px);">Sube tu acta de
                  nacimiento <small>(Actualizada, escaneada, legible)</small>:</label>
                <label :for="'acta-input' + index" class="btn-label">
                  <img :src="'/img/icons/' + uploadIcon" style="width: 20px;" />
                  SUBIR ACTA
                </label>
                <input type="file" accept="application/pdf" name="file" :id="'acta-input' + index"
                  style="visibility: hidden;" @change="uploadActa" />
              </div>
              <validation-error :validation="$v.actaUrl"></validation-error>
              <div v-show="actaUrl != null" class="input-group">
                <btn :text="'¡LISTO!'" :type="'primary-admin-success'" style="float:left;"></btn>

                <img style="margin-top: 10px; cursor: pointer;" :src="'/img/icons/' + watchButton"
                  @click="viewPdf(actaUrl, 'Acta de nacimiento')" @mouseup="mouseUpIcon('watch')"
                  @mousedown="mouseDownIcon('watch')" @mouseleave="mouseLeaveIcon('watch')" />
              </div>
            </div>

            <div class="invalid-feedback">
              <HelperMessage type="error" text="Tu CURP es invalido" />
            </div>
            <div v-show="CURPimageError">
              <HelperMessage type="error" text="Sube tu CURP (Actualizada, legible)" />
            </div>
            <div v-if="imageError">
              <HelperMessage type="error" text="Sube una foto" />
            </div>
            <div v-if="IneImageError">
              <HelperMessage type="error" text="Sube una identificación oficial" />
            </div>
          </div>
        </mdb-col>
      </mdb-row>
    </div>

    <Loader v-show="isLoading" />
    <Popup ref="camera" size="md">
      <div class="text-center">
        <mdb-row>
          <mdb-col md="6">
            <mdb-row>
              <h2>Cámara</h2>
              <div class="border">
                <vue-web-cam ref="webcam" :device-id="deviceId" width="100%" height="100%" @started="onStarted"
                  @stopped="onStopped" @error="onError" @cameras="onCameras" @camera-change="onCameraChange" />
              </div>
            </mdb-row>
            <mdb-row>
              <div class="col-md-12">
                <select v-model="camera">
                  <option>-- Selecciona cámara --</option>
                  <option v-for="device in devices" :key="device.deviceId" :value="device.deviceId">{{ device.label }}
                  </option>
                </select>
              </div>
              <div class="col-md-12">
                <button type="button" class="btn btn-primary" @click="onCapture">
                  Tomar foto
                </button>
              </div>
            </mdb-row>
          </mdb-col>
          <mdb-col v-if="imgSrc" md="6">
            <mdb-row>
              <h2>Foto Capturada</h2>
              <vue-cropper ref="cropper" :aspect-ratio="9 / 9" :src="imgSrc" preview=".preview" />
            </mdb-row>
            <mdb-row>
              <div class="col-md-12">
                <button type="button" class="btn btn-primary" @click="cropImage">
                  Recortar
                </button>
              </div>
            </mdb-row>
          </mdb-col>
          <mdb-col v-if="imgSrc" md="12">
            <mdb-row>
              <div class="col-md-12">
                <h2>Vista Previa</h2>
                <div class="image-upload">
                  <label for="image-release">
                    <img :src="imgSrc" class="avatar-pic" alt="Profile Picture" style="cursor: pointer;" />
                  </label>
                </div>
              </div>
            </mdb-row>
            <mdb-row>
              <div class="col-md-12">
                <button type="button" class="btn btn-primary"
                  @click="
                    $refs.camera.toggleModal();
                  $refs.webcam.stop();
                                                                                                                                                                    ">
                  Finalizar edición
                </button>
              </div>
            </mdb-row>
          </mdb-col>
        </mdb-row>
      </div>
    </Popup>
    <Popup size="lg" ref="confirm" :title="titleModal">
      <div class="embed-responsive embed-responsive-16by9 z-depth-1-half" style="height: 75vh;">
        <iframe title="titulo" class="embed-responsive-item" :src="popUrl" allowfullscreen></iframe>
      </div>
      <div class="accordion__button">
        <btn style="float: left;" text="CERRAR" @onClick="$refs.confirm.toggleModal()" type="primary-block" />
      </div>
    </Popup>
    <Popup title="Selecciona tu fecha de nacimiento" size="sm" ref="filterDay">
      <mdb-container class="mt-4">
        <mdb-row>
          <mdb-col col="12" class="d-flex justify-content-center align-items-center">
            <datepicker :inline="true" minimum-view="day" :language="languageDatePicker" v-model="datePickerValue"
              calendar-class="datepicker"></datepicker>
          </mdb-col>
        </mdb-row>
        <mdb-row class="mt-3">
          <mdb-col class="d-flex justify-content-center align-items-center">
            <btn @onClick="$refs.filterDay.toggleModal()" :text="'Cancelar'" :type="'primary-admin-ghost'" class="mr-4">
            </btn>
            <btn @onClick="setFilterDay" :text="'Aceptar'" :type="'primary-admin'"></btn>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </Popup>
  </div>
</template>

<script>
import btn from "../../core/Button";
import { mdbContainer, mdbRow, mdbCol, Alert } from "mdbvue";
import { WebCam } from "vue-web-cam";
import HelperMessage from "../../core/HelperMessage.vue";
import Swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import Loader from "../../core/Loader";
import Popup from "../../core/Popup";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { mask } from "vue-the-mask";
import { required, requiredIf } from "vuelidate/lib/validators";
import ValidationError from "../misc/ValidationError";
import Datepicker from "vuejs-datepicker";
import moment, { now } from "moment";
import { es } from "vuejs-datepicker/dist/locale";

export default {
  name: "ChildPersonalData",
  props: ["isMayor", "index"],
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    btn,
    HelperMessage,
    Loader,
    "vue-web-cam": WebCam,
    VueCropper,
    Popup,
    ValidationError,
    Datepicker,
  },
  directives: { mask },
  data() {
    return {
      languageDatePicker: es,
      datePickerValue: new Date(),
      imgSrc: null,
      camera: null,
      deviceId: null,
      devices: [],
      curp: "",
      invalidChild: false,
      fileAvatar: "",
      fileCurp: null,
      fileIne: null,
      estadoCivil: "MARRIED",
      uploadIcon: "upload-document.svg",
      releaseIcon: "release-default.svg",
      approvedIcon: "approved-2.svg",
      watchButton: "watch-unpressed-btn.svg",
      iconEdit: "editar-default.svg",
      iconDelete: "borrar-default.svg",
      showCard: false,
      filesCurp: null,
      filesIne: null,
      filesProfile: null,
      imageError: false,
      CURPimageError: false,
      IneImageError: false,
      candidates: [],
      isLoading: false,
      isCorrect: true,
      isInCorrect: false,
      urlAvatar: "",
      sexo: "",
      dia: "",
      mes: "",
      year: "",
      name: "",
      lastName: "",
      lastName2: "",
      state: "",
      step2: false,
      curpOK: false,
      ineOK: false,
      documentType: "",
      extension: "",
      extensionIne: "",
      messageIne: "",
      documentValue: "",
      popUrl: null,
      ////////
      pdfUrl: null,
      filesPDF: null,
      recomendations: [],
      singleRe: {
        firstName: "",
        lastName: "",
        motherLastName: "",
        accion: "",
        email: "",
        phone: "",
      },
      nameCompany: "",
      phoneCompany: "",
      currentPosition: "",
      indexDelete: 0,
      ////////////////
      actaUrl: null,
      actaPDF: null,
      titleModal: "",
      //////CHILDS
      childrens: [],
      disabledCurp: true,
      locations: [
        "AGUASCALIENTES",
        "BAJA CALIFORNIA",
        "BAJA CALIFORNIA SUR",
        "CAMPECHE",
        "COAHUILA",
        "COLIMA",
        "CHIAPAS",
        "CHIHUAHUA",
        "DISTRITO FEDERAL",
        "DURANGO",
        "GUANAJUATO",
        "GUERRERO",
        "HIDALGO",
        "JALISCO",
        "MÉXICO",
        "MICHOACÁN",
        "MORELOS",
        "NAYARIT",
        "NUEVO LEÓN",
        "OAXACA",
        "PUEBLA",
        "QUERÉTARO",
        "QUINTANA ROO",
        "SAN LUIS POTOSÍ",
        "SINALOA",
        "SONORA",
        "TABASCO",
        "TAMAULIPAS",
        "TLAXCALA",
        "VERACRUZ",
        "YUCATÁN",
        "ZACATECAS",
      ],
    };
  },
  validations: {
    curp: { required },
    fileCurp: {
      required: requiredIf(function () {
        if (this.fileCurp != null) {
          return false;
        } else {
          return true;
        }
      }),
    },
    fileIne: {
      required: requiredIf(function () {
        if (this.fileIne != null) {
          return false;
        } else {
          return true;
        }
      }),
    },
    actaUrl: {
      required: requiredIf(function () {
        if (this.actaUrl != null) {
          return false;
        } else {
          return true;
        }
      }),
    },
  },
  methods: {
    ...mapActions([
      "getCurpInfo",
      "completeStep1",
      "postDataSpouse",
      "sendInvestigation",
    ]),
    viewPdf(url, title) {
      this.popUrl = url;
      this.titleModal = title;
      this.$refs.confirm.toggleModal();
    },
    uploadWorker: function (evt) {
      this.pdfUrl = URL.createObjectURL(evt.target.files[0]);
      let aux = this;
      var rdr = new FileReader();
      rdr.onload = function (e) {
        aux.filesPDF = e.target.result.split(",")[1];
      };
      rdr.readAsDataURL(evt.target.files[0]);
    },
    checkForm(form) {
      return (
        Object.keys(form).length ===
        Object.keys(form).filter((key) => form[key].length > 0).length
      );
    },

    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.imgSrc = this.$refs.cropper.getCroppedCanvas().toDataURL();
      this.fileAvatar = this.imgSrc;
      //console.log(this.fileAvatar)
    },
    reset() {
      this.fileAvatar = "";
      this.$refs.cropper.reset();
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    move(offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY);
    },
    mouseOverIcon(module) {
      if (module == "upload") {
        let uploadIcon = this.uploadIcon.split("-");
        this.uploadIcon = `${uploadIcon[0]}-document.svg`;
      } else if (module == "release") {
        let releaseIcon = this.releaseIcon.split("-");
        this.releaseIcon = `${releaseIcon[0]}-hover.svg`;
      } else {
        let helpIcon = this.helpIcon.split("-");
        this.helpIcon = `${helpIcon[0]}-hover.svg`;
        this.showCard = true;
      }
    },
    mouseLeaveIcon(module) {
      if (module == "upload") {
        let uploadIcon = this.uploadIcon.split("-");
        this.uploadIcon = `${uploadIcon[0]}-document.svg`;
      } else if (module == "release") {
        let releaseIcon = this.releaseIcon.split("-");
        this.releaseIcon = `${releaseIcon[0]}-default.svg`;
      } else if (module == "watch") {
        this.watchButton = "watch-unpressed-btn.svg";
      } else {
        let helpIcon = this.helpIcon.split("-");
        this.helpIcon = `${helpIcon[0]}-default.svg`;
        this.showCard = false;
      }
    },
    mouseDownIcon(module) {
      if (module == "upload") {
        let uploadIcon = this.uploadIcon.split("-");
        this.uploadIcon = `${uploadIcon[0]}-document.svg`;
      } else if (module == "watch") {
        this.watchButton = "watch-pressed-btn.svg";
      } else {
        let releaseIcon = this.releaseIcon.split("-");
        this.releaseIcon = `${releaseIcon[0]}-click.svg`;
      }
    },
    mouseUpIcon(module) {
      if (module == "upload") {
        let uploadIcon = this.uploadIcon.split("-");
        this.uploadIcon = `${uploadIcon[0]}-document.svg`;
      } else if (module == "watch") {
        this.watchButton = "watch-unpressed-btn.svg";
      } else {
        let releaseIcon = this.releaseIcon.split("-");
        this.releaseIcon = `${releaseIcon[0]}-hover.svg`;
      }
    },
    UploadIdentificacion: function (evt) {
      this.fileIne = URL.createObjectURL(evt.target.files[0]);
      this.extensionIne = evt.target.files[0].type;
      let aux = this;
      var rdr = new FileReader();
      rdr.onload = function (e) {
        aux.filesIne = e.target.result.split(",")[1];
        // aux.isLoading = true;
        // aux.readIne(aux.filesIne);
      };
      rdr.readAsDataURL(evt.target.files[0]);
    },
    uploadCURP: function (evt) {
      this.fileCurp = URL.createObjectURL(evt.target.files[0]);
      this.extension = evt.target.files[0].type;
      let aux = this;
      var rdr = new FileReader();
      rdr.onload = function (e) {
        aux.filesCurp = e.target.result.split(",")[1];
        // aux.isLoading = true;
        // aux.readCurp(aux.filesCurp);
      };
      rdr.readAsDataURL(evt.target.files[0]);
    },
    async setFilterDay() {
      try {
        if (this.$refs.filterDay.open) {
          this.$refs.filterDay.toggleModal();
        }
        //console.log(this.datePickerValue);
        const date = moment(this.datePickerValue).format("DD-MM-YYYY");

        //console.log(date);
        this.dia = date.split("-")[0];
        this.mes = date.split("-")[1];
        this.year = date.split("-")[2];
      } catch (e) {
        this.pushNotifyError();
      } finally {
      }
    },
    cleanCurp() {
      this.curp = "";
      this.fileAvatar = "";
      this.fileCurp = "";
      this.fileIne = "";
    },
    validateFile() {
      var d = new Date();
      var n = d.getFullYear();

      if (this.isMayor) {
        if (n - Number(this.year) >= 18 && n - Number(this.year) <= 27) {
          return true;
        } else {
          return false;
        }
      } else {
        if (n - Number(this.year) < 18) {
          return true;
        } else {
          return false;
        }
      }
    },
    async validateCURP() {
      // event.preventDefault();
      // event.target.classList.add("was-validated");

      try {
        if (this.curp.length == 18) {
          this.isLoading = true;
          let isCorrect = await this.getCurpInfo({
            curp: this.curp,
            foto: this.fileAvatar,
          });
          this.isLoading = false;

          if (isCorrect) {
            this.getCandidateInfo();
            var isValid = this.validateFile();

            //this.cleanCurp();
            // if (isValid) {
            //   this.curpOK = true;
            // } else {

            // }

            // this.step2 = true;
          } else {
            this.$notify.error({
              message: "CURP incorrecta, favor de verificar",
              position: "top right",
              timeOut: 5000,
            });
          }
        }
      } catch (error) {
        this.isLoading = false;
        //console.log(error.response);
        if (error.response.status == 409) {
          Swal.fire({
            title:
              "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #dc7134'>¡ATENCIÓN!</span>",
            html:
              "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
              "<p>La CURP proporcionada ya esta registrada.</p>" +
              "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +
              "</div>",
            allowOutsideClick: false,
            width: "50rem",
            padding: "2rem",
            confirmButtonText: "Ok",
            confirmButtonColor: "#dc7134",
            customClass: {
              confirmButton: "t1-btn t1-btn--primary-block",
            },
            reverseButtons: true,
            onClose: () => { },
          }).then((result) => { });
        } else {
          this.$notify.error({
            message:
              "El servicio de lectura de CURP no esta disponible, favor de ingresar sus datos manualmente",
            position: "top right",
            timeOut: 15000,
          });
          this.disabledCurp = false;
        }
      }
    },
    getCandidateInfo() {
      //this.candidate = this.$store.state.candidate.candidateInfo
      this.name = this.candidate.name;
      this.lastName = this.candidate.lastName;
      this.lastName2 = this.candidate.lastName2;
      this.sexo = this.candidate.sexo;
      this.state = this.candidate.state;
      this.dia = this.candidate.dia;
      this.mes = this.candidate.mes;
      this.year = this.candidate.year;
      this.urlAvatar = this.candidate.urlAvatar;
      this.curp = this.candidate.curp;
    },
    uploadActa: function (evt) {
      this.actaUrl = URL.createObjectURL(evt.target.files[0]);
      let aux = this;
      var rdr = new FileReader();
      rdr.onload = function (e) {
        aux.actaPDF = e.target.result.split(",")[1];
      };
      rdr.readAsDataURL(evt.target.files[0]);
    },
    uploadFile: function (evt) {
      this.fileAvatar = URL.createObjectURL(evt.target.files[0]);
      let aux = this;
      var rdr = new FileReader();
      rdr.onload = function (e) {
        aux.filesProfile = e.target.result.split(",")[1];
      };
      rdr.readAsDataURL(evt.target.files[0]);
    },

    getFormdata() {
      if (this.fileAvatar == "") {
        this.imageError = true;
        return false
      }

      if (
        this.fileCurp != null &&
        this.actaUrl != null &&
        (this.fileIne != null || !this.isMayor) &&
        this.fileAvatar != "" &&
        this.name != "" &&
        this.lastName != "" &&
        this.lastName2 != "" &&
        this.sexo != "" &&
        this.dia != "" &&
        this.mes != "" &&
        this.year != "" &&
        this.state != ""
      ) {
        if (this.dia <= 9) {
          if (this.dia.length == undefined || this.dia.length < 2)
            this.dia = "0" + this.dia;
        }
        if (this.mes <= 9) {
          if (this.mes.length == undefined || this.mes.length < 2)
            this.mes = "0" + this.mes;
        }

        let body = {
          lastName: this.lastName,
          motherLastName: this.lastName2,
          name: this.name,
          birthDate: this.dia + "-" + this.mes + "-" + this.year,
          birthPlace: this.state,
          documentsDTO: [
            {
              documentType: "CURP",
              value: this.curp,
              extension: "pdf",
              mimeType: "application/pdf",
              content: this.filesCurp,
            },
            {
              documentType: "PROFILE_PICTURE",
              value: "",
              extension: "jpeg",
              mimeType: "image/jpeg",
              content: this.fileAvatar.split(",")[1],
            },
            {
              documentType: "BIRTH_CERTIFICATE",
              value: "",
              extension: "pdf",
              mimeType: "application/pdf",
              content: this.actaPDF,
            },
          ],
        };

        if (this.isMayor) {
          let ineBody = {
            documentType: "INE",
            value: "",
            extension: "pdf",
            mimeType: "application/pdf",
            content: this.filesIne,
          };

          body.documentsDTO.push(ineBody);
        }

        return body;
      } else {
        return false;
      }
    },
    onCapture() {
      this.imgSrc = this.$refs.webcam.capture();
      this.$refs.cropper.replace(this.imgSrc);
      //this.$refs.camera.toggleModal();
      //this.$refs.webcam.stop();
      //this.fileAvatar = this.imgSrc;
    },
    onStarted(stream) {
      //console.log("On Started Event", stream);
    },
    onStopped(stream) {
      //console.log("On Stopped Event", stream);
    },
    onStop() {
      this.$refs.webcam.stop();
    },
    onStart() {
      this.$refs.webcam.start();
    },
    onError(error) {
      //console.log("On Error Event", error);
    },
    onCameras(cameras) {
      this.devices = cameras;
      //console.log("On Cameras Event", cameras);
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId;
      //console.log("On Camera Change Event", deviceId);
    },
    closeMessageError() {
      Swal.fire({
        title:
          "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #dc7134'>¡ATENCIÓN!</span>",
        html:
          "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
          "<p>¿Estás seguro de cerrar la ventana para crear tu solicitud? Si haces esto la solicitud no será generada.</p>" +
          "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +
          "</div>",
        allowOutsideClick: false,
        showCancelButton: true,
        width: "50rem",
        padding: "2rem",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#dc7134",
        customClass: {
          cancelButton: "t1-btn t1-btn--ghost",
          confirmButton: "t1-btn t1-btn--primary-block",
        },
        reverseButtons: true,
        onClose: () => { },
      }).then((result) => {
        if (result.value) {
          this.$router.push("/home");
        }
      });
    },
    getChildInfo(child) {
      var documentAvatar = child.documents.filter(function (item) {
        return item.documentType == "PROFILE_PICTURE";
      });
      this.fileAvatar = documentAvatar[0].publicURL;

      var documentActa = child.documents.filter(function (item) {
        return item.documentType == "BIRTH_CERTIFICATE";
      });
      this.actaUrl = documentActa[0].publicURL;

      var documentCurp = child.documents.filter(function (item) {
        return item.documentType == "CURP";
      });
      this.curp = documentCurp[0].value;
      this.validateCURP();
      this.fileCurp = documentCurp[0].publicURL;

      if (this.isMayor) {
        var documentId = child.documents.filter(function (item) {
          return item.documentType == "INE";
        });
        this.fileIne = documentId[0].publicURL;

        //var documentTax = this.child[0].documents.filter(function(item){return item.documentType=='TAX_STATUS_LETTER'})
      }
    },
  },
  mounted() {
    //this.$refs.webcam.stop();

    this.childrens = this.beneficiaries.filter(function (item) {
      return item.beneficiaryType != "SPOUSE";
    });

    if (this.childrens.length > 0) {
      this.getChildInfo(this.childrens[this.index]);
    }
  },
  computed: {
    ...mapGetters({
      candidate: "getCandidate",
      maritalStatus: "getMaritalStatus",
      beneficiaries: "getBeneficiariesData",
    }),
    treeImg() {
      if (this.maritalStatus == "MARRIED") {
        return "/img/progress/W025.svg";
      } else {
        return "/img/progress/W02.svg";
      }
    },
    device: function () {
      return this.devices.find((n) => n.deviceId === this.deviceId);
    },
    displayedPost() {
      return this.recomendations;
    },
  },
  watch: {
    fileAvatar(value) {
      if (value != "") {
        this.imageError = false;
      }
    },
    fileCurp(value) {
      if (value != "") {
        this.CURPimageError = false;
      }
    },
    fileIne(value) {
      if (value != "") {
        this.IneImageError = false;
      }
    },
    async curp(value) {
      if (value.length == 18) {
        var regex = /^([A-Z&]|[a-z&]{1})([AEIOUX]|[aeioux]{1})([A-Z&]|[a-z&]{1})([A-Z&]|[a-z&]{1})([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])([HM]|[hm]{1})([AS|as|BC|bc|BS|bs|CC|cc|CS|cs|CH|ch|CL|cl|CM|cm|DF|df|DG|dg|GT|gt|GR|gr|HG|hg|JC|jc|MC|mc|MN|mn|MS|ms|NT|nt|NL|nl|OC|oc|PL|pl|QT|qt|QR|qr|SP|sp|SL|sl|SR|sr|TC|tc|TS|ts|TL|tl|VZ|vz|YN|yn|ZS|zs|NE|ne]{2})([^A|a|E|e|I|i|O|o|U|u]{1})([^A|a|E|e|I|i|O|o|U|u]{1})([^A|a|E|e|I|i|O|o|U|u]{1})([0-9]{2})$/g;

        if (regex.test(value)) {
          let genero = value.charAt(10)
          let year = value.substring(4, 6)
          let mes = value.substring(6, 8)
          let dia = value.substring(8, 10)


          //if (genero === 'H') {
          let limite = new Date();
          let pibote = Number("19" + limite.getFullYear().toString().substring(2, 4))
          limite.setFullYear(limite.getFullYear() - 27)

          let nacimiento = new Date(year, mes - 1, dia)

          if (nacimiento.getFullYear() <= pibote) {
            nacimiento.setFullYear(nacimiento.getFullYear() + 100)
          }

          this.invalidChild = (limite > nacimiento)
          // } else {
          //   this.invalidChild = false
          // }
        }
      }
    },
    isCorrect(newValue) {
      this.isInCorrect = !newValue;
    },
    isInCorrect(newValue) {
      this.isCorrect = !newValue;
    },
    camera: function (id) {
      this.deviceId = id;
    },
    devices: function () {
      // Once we have a list select the first one
      const [first, ...tail] = this.devices;
      if (first) {
        this.camera = first.deviceId;
        this.deviceId = first.deviceId;
      }
    },
    year(value) {
      if (value.length == 4) {

        var d = new Date();
        var n = d.getFullYear();
        if (this.isMayor) {

          if (n - Number(value) > 27 && this.sexo != "MUJER") {
            Swal.fire({
              title:
                "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #dc7134'>¡ATENCIÓN!</span>",
              html:
                "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
                "<p>La CURP proporcionada es de un(a) hijo mayor de 27 años de edad, por lo que no es posible registrarlo. Tu hijo mayor debe de ser menor de 27 años y mayor o igual de 18 años.</p>" +
                "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +
                "</div>",
              allowOutsideClick: false,
              width: "50rem",
              padding: "2rem",
              confirmButtonText: "Ok",
              confirmButtonColor: "#dc7134",
              customClass: {
                confirmButton: "t1-btn t1-btn--primary-block",
              },
              reverseButtons: true,
              onClose: () => { },
            }).then((result) => { });
          } else if (n - Number(value) < 17) {
            Swal.fire({
              title:
                "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #dc7134'>¡ATENCIÓN!</span>",
              html:
                "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
                "<p>La CURP proporcionada es de un(a) hij@ menor de edad, por lo que no es posible registrarl@ como hij@ mayor. Por favor registra a tu hij@ como menor de edad.</p>" +
                "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +
                "</div>",
              allowOutsideClick: false,
              width: "50rem",
              padding: "2rem",
              confirmButtonText: "Ok",
              confirmButtonColor: "#dc7134",
              customClass: {
                confirmButton: "t1-btn t1-btn--primary-block",
              },
              reverseButtons: true,
              onClose: () => { },
            }).then((result) => { });
          }
        } else if (n - Number(value) > 17) {
          Swal.fire({
            title:
              "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #dc7134'>¡ATENCIÓN!</span>",
            html:
              "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
              "<p>La CURP proporcionada es de un(a) hij@ mayor de edad, por lo que no es posible registrarl@ como hij@ menor. Por favor registra a tu hij@ como mayor de edad.</p>" +
              "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +
              "</div>",
            allowOutsideClick: false,
            width: "50rem",
            padding: "2rem",
            confirmButtonText: "Ok",
            confirmButtonColor: "#dc7134",
            customClass: {
              confirmButton: "t1-btn t1-btn--primary-block",
            },
            reverseButtons: true,
            onClose: () => { },
          }).then((result) => { });
        }
      }
    },
  },
};
</script>

<style scoped>
.input-group-prepend>input::placeholder {
  font-size: 14px;
}

.uploadIcon {
  cursor: pointer;
  background-color: rgb(220, 113, 52);
  padding: 9.4px;
  border-radius: 0px 4px 4px 0px;
  /* margin-top: 12px;
    margin-left: 20px; */
}

.approvedIcon {
  width: 5rem;
}

.class-container {
  background: #fff !important;
  height: 100%;
  width: 100%;
  padding-top: 1rem;
  padding-bottom: 9vh;
}

.center {
  margin: auto;
  margin-top: 120px;
  width: 60%;

  padding-bottom: 20%;
}

.text-style {
  font-size: 27px;
  color: #285f46;
  font-weight: 600;
  text-transform: uppercase;
}

.text-style-2 {
  font-size: 20px;
  color: #285f46;
  font-weight: normal;
}

.Rectangle-78 {
  width: 1px;
  height: 100%;
  border: 1px solid #285f46;
}

.Rectangle-366 {
  width: 882px;
  height: 205px;
  border-radius: 5px;
  border: solid 1px #3a8a65;
}

.btn-crear {
  width: 10rem;
  height: 3rem;
  border-radius: 3.5px;
  background-color: #dc7134;
  color: #ffffff;
  font-size: 12px;
}

.btn-cancelar {
  width: 11.5rem;
  height: 3rem;
  border: 1px solid #bdbdbd;
  border-radius: 3.5px;
  background-color: #ffffff;
  color: #bdbdbd;
  font-size: 12px;
}

.curp-upload>input {
  display: none;
}

.image-upload>input {
  display: none;
}

.btn-label {
  border-radius: 5px;
  background-color: #dc7134;
  padding: 0.4rem 2.5rem;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
  font-weight: 600;
  font-family: Josefin Sans;
  cursor: pointer;
}

.btn-edit {
  padding: 6px;
  background-color: #c4c4c4 !important;
  border-radius: 3px;
  box-shadow: unset;
}

.btn-edit:hover {
  background-color: #f78c4f !important;
}

.btn-edit:active {
  background-color: #dc7134 !important;
}

.btn-delete {
  padding: 6px;
  background-color: #c4c4c4 !important;
  border-radius: 3px;
  box-shadow: unset;
}

.btn-delete:hover {
  background-color: #eb5757 !important;
}

.btn-delete:active {
  background-color: #d65050 !important;
}

.divLine {
  width: 100%;
  border: 0.1rem solid #828282;
}

.edit-pic {
  cursor: pointer;
  position: absolute;
  z-index: 100;
}

.avatar-pic {
  /* position: absolute; */
  /* border: 0.6rem solid #285f46; */
  border-radius: 50%;
  width: 13rem;
  height: 13rem;
}

.help-curp {
  width: 29rem;
  position: absolute;
  bottom: 0rem;
  z-index: 10000;
}

.split {
  border: 0.15rem solid #bdbdbd;
  font-size: 1.5rem;
  padding: 0.6rem 1rem;
  border-radius: 0.8rem;
  width: 30%;
  color: #828282;
  transition: all 0.2s;
  text-align: center;
}

.form-check-input[type="checkbox"]:checked+label:before,
label.btn input[type="checkbox"]:checked+label:before {
  top: -4px;
  /* left: -5px; */
  width: 11px;
  height: 18px;
  border-top: 2px solid transparent;
  border-right: 2px solid #f78c4f;
  border-bottom: 2px solid #f78c4f;
  border-left: 2px solid transparent;
  -webkit-transform: rotate(40deg);
  transform: rotate(40deg);
  -webkit-transform-origin: 100% 100%;
  transform-origin: 100% 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.form-check-input[type="checkbox"]+label:before,
.form-check-input[type="checkbox"]:not(.filled-in)+label:after,
label.btn input[type="checkbox"]+label:before,
label.btn input[type="checkbox"]:not(.filled-in)+label:after {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 18px;
  height: 18px;
  margin-top: 3px;
  content: "";
  border: 2px solid #8a8a8a;
  border-radius: 1px;
  -webkit-transition: 0.2s;
  transition: 0.2s;
}

@media (max-width: 80.2rem) {
  .cardClass {
    padding-bottom: 3rem;
  }
}

@media (min-height: 850px) {
  .class-container {
    padding-bottom: 40vh;
  }

  /* .uploadIcon{
    margin-top: 3px;
   
} */
}

.table td {
  font-size: 12px;
  font-family: Open Sans;
  text-transform: uppercase;
}

.btn-acta-nacimiento {
  display: inline-block;
  margin-left: 10px;
}
</style>
